import { render, staticRenderFns } from "./DisabilityMedicalInfoSection.vue?vue&type=template&id=c6ffba62&scoped=true"
import script from "./DisabilityMedicalInfoSection.vue?vue&type=script&lang=js"
export * from "./DisabilityMedicalInfoSection.vue?vue&type=script&lang=js"
import style0 from "./DisabilityMedicalInfoSection.vue?vue&type=style&index=0&id=c6ffba62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ffba62",
  null
  
)

export default component.exports